var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "alert alert-danger validation-error-alert"
  }, _vm._l(_vm.validationErrors, function (value, index) {
    return _c('li', {
      key: index
    }, [_vm._v(" " + _vm._s(value) + " ")]);
  }), 0);
}
var staticRenderFns = []

export { render, staticRenderFns }